// @flow
import { connect } from 'react-redux';
import { compose } from 'redux';
import type { Dispatch } from 'redux';
import { injectIntl } from 'react-intl';
import { clickoutRequest, hideRelatedAdsPopup } from '../../Serp/actions';
import withConfig from '../../hoc/WithConfig';
import SnippetModalComponent from '.';
import { getVerticalName } from '../selectors/config';

type Props = {
  ad: Object,
};

type MapDispatchToProps = {
  onItemClicked: Function,
};

type MapStateToProps = {
  verticalName: string,
};

function mapDispatchToProps(dispatch: Dispatch<*>, { ad }: Props): MapDispatchToProps {
  return {
    onItemClicked(e) {
      e.preventDefault();

      dispatch(hideRelatedAdsPopup());
      dispatch(clickoutRequest(ad));
    },
  };
}

function mapStateToProps(state: Object): MapStateToProps {
  return {
    verticalName: getVerticalName(state),
  };
}

const SnippetModalContainer = compose(
  withConfig,
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(SnippetModalComponent);

export default SnippetModalContainer;



// WEBPACK FOOTER //
// ./app/common/SnippetModal/container.js